import React from 'react'
import { Header } from 'components/Header'
import { Button, Flex } from '@workwhile/ui'
import { QueryStatus } from 'components/QueryStatus'
import { useInvoiceConfigContextValue } from '../context/InvoiceConfigProvider'
import { useInvoiceConfigWorkflowsContextValue } from '../context/InvoiceConfigWorkflowsProvider'
import { useWhoamiContextValue } from 'components/Whoami'

export const InvoiceConfigHeader = () => {
  const { state, actions } = useInvoiceConfigContextValue()
  const { createInvoiceConfigFlow } = useInvoiceConfigWorkflowsContextValue()
  const { hasPermission } = useWhoamiContextValue()
  const canManageBilling = hasPermission('finance_specialist')

  return (
    <Header
      title="Invoice Config"
      rightContent={
        <Flex alignItems="center" gap={2}>
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
          {canManageBilling ? (
            <Button
              variant="primary"
              kind="medium"
              onClick={createInvoiceConfigFlow.open}
            >
              Create Invoice Config
            </Button>
          ) : null}
        </Flex>
      }
    />
  )
}
